var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isLeaflet    = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isLeaflet = true;
  }
}

const Leaflet = (
  await import(`${isLeaflet ? `https://ga.jspm.io/npm:leaflet@1.9.4/dist/leaflet-src.js` : `./leaflet`}`)
).default

$(document).ready(function() {
  // Init modal
  const modalLocation = document.getElementById('modal-branch-loc-detail');

  if (modalLocation) {
    // Map init
    const locDetail = new bootstrap.Modal(modalLocation);

    var latLong        = [4.2105, 101.9758]
    var list_branches = $('.list-branches')
    list_branches = list_branches.map(function(_idx, el){
      if (el.dataset.branchLatitude !== '' && el.dataset.branchLongitude !== '') {
        return [[parseFloat(el.dataset.branchLatitude), parseFloat(el.dataset.branchLongitude)]] 
      }
    })

    if (list_branches.length >= 1) {
      latLong = list_branches[0]
    }

    let mapOptions = {
      center: latLong,
      zoom: 10,
    }
  
    const mapEl = document.querySelector('#map')
    if (!mapEl) {
      return null
    }
  
    let map = L.map('map', mapOptions)
  
    let layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
  
    map.addLayer(layer)
    map.zoomControl.remove()

    // Update map center to current user loc
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        map.panTo(new L.LatLng(position.coords.latitude, position.coords.longitude));
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  
    // Marker init
    let iconOptions = {
      iconUrl: '/assets/liquids/assets/icons/pin-dark.svg',
      iconSize: [42, 42],
      iconAnchor: [16, 32],
    }
  
    var tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
    tabLinks.forEach(function(tabLink) {
      tabLink.addEventListener('shown.bs.tab', function (e) {
        map.invalidateSize();
      });
    });
  
    $.ajax({
      url: '/user/branches/fetch_branch_datas',
      method: 'get',
      contentType: 'application/json',
      data: {},
      dataType: 'json',
      success: function(res) {
        res['branches'].forEach(branch => {
          if (branch.latitude && branch.longitude) {
            let marker = L.marker(branch.coordinates, { icon: L.icon(iconOptions), title: branch.name }).addTo(map)
            marker.on('click', function () {
              var branch_name    = branch.name
              var branch_address = branch.address
              var branch_wa_link = branch.details.whatsapp_link || 'javascript:;'
              var contact_link = branch.contact ? `tel:${branch.contact}` : 'javascript:;'
              $('#branch-name').text(branch_name)
              $('#branch-address').text(branch_address)
              $('#link-view-detail').attr('href', `/user/branch/${branch.branch_id}`)
              $('#popup-map-direction').attr('data-branch-id', branch.branch_id)
              if (branch.details.gmap_link || branch.details.waze_link) {
                $('#popup-map-direction').removeClass('d-none')
              } else {
                $('#popup-map-direction').addClass('d-none')
              }
              $('#branch-thumbnail').attr('src', branch.images[0])
              $('#whatsapp_link').attr('href', branch_wa_link)
              $('#contact_link').attr('href', contact_link)
              if (branch['open?']) {
                $('#open-status').html('Open')
                $('#open-status').addClass('badge-success-overlay')
              } else {
                $('#open-status').html('Closed')
                $('#open-status').addClass('badge-danger-overlay')
              }
              locDetail.show()
            })
          }
        })
      },
      error: (err, status) => {
        console.log(err.responseJSON.error)
      }
    });
  }
})

